export const API = "https://atmasampanna.onrender.com"
